import { useRef, useEffect } from 'react';
import styles from '../styles/animations.module.scss';

/**
 * Hook for spin in/out animation state management.
 * Returns CSS class name based on visibility state.
 *
 * @param {boolean} isVisible - Current visibility state
 * @returns {{ animationClass: string }}
 */
export function useSpinAnimation(isVisible) {
  const hasBeenVisibleRef = useRef(false);

  useEffect(() => {
    if (isVisible) {
      hasBeenVisibleRef.current = true;
    }
  }, [isVisible]);

  let animationClass = '';
  if (isVisible) {
    animationClass = styles.spinIn;
  } else if (hasBeenVisibleRef.current) {
    animationClass = styles.spinOut;
  } else {
    animationClass = styles.hidden;
  }

  return { animationClass };
}
